module.exports = __webpack_public_path__ + "img/transport_pic02.c4d10e6f.jpg";